import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.scss';
import { polyfillCountryFlagEmojis } from 'country-flag-emoji-polyfill';
import { Provider } from 'react-redux';
import { store } from './redux/store';
polyfillCountryFlagEmojis();
const queryClient = new QueryClient();
const rootElement = document.getElementById('root');
const root = ReactDOM.createRoot(rootElement);
root.render(
// (!) in react 18, StrictMode causes all useEffect-s to trigger twice on freshly rendered components
_jsx(React.StrictMode, { children: _jsx(Provider, { store: store, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx(App, {}) }) }) }));
